import cn from "classnames";
import { t } from "i18next";

import { FormFieldProps } from "./FormField.types";

import styles from "./FormField.module.scss";

const FormField = ({
  children,
  label,
  errorMessage,
  labelClassName,
  containerClassName
}: FormFieldProps) => {
  return (
    <div className={cn(styles["form-field"], containerClassName)}>
      {label ? (
        <div className={cn(styles["form-field__label"], labelClassName)}>
          {typeof label === "string" ? t(label) : label}
        </div>
      ) : null}
      {children}
      {errorMessage ? (
        <div className={styles["form-field__error"]}>{t(errorMessage)}</div>
      ) : null}
    </div>
  );
};

export default FormField;
